import { jsx } from 'panel';
import { AsyncButtonEl } from 'common/components/async-button';
import { BannerEl } from 'common/components/banner';
import { ButtonEl } from 'common/components/button';
import { InputEl } from 'common/components/input';
import { ModalEl } from 'common/components/modal';
import { SelectEl } from 'common/components/select';
import { TooltipEl } from 'common/components/tooltip';
import { BannerAction, BannerType } from 'common/components/banner/types';
import { ButtonTheme } from 'common/components/button/constants';
import { SharingBannerEl } from '../sharing/banner'; // eslint-disable-next-line sonarjs/cognitive-complexity

export function template() {
  var _this = this;

  const {
    description,
    globalAccessType,
    name,
    saving
  } = this.state;
  const entityTypeNameTitle = this.helpers.getEntityTypeName(this.attr("entity-type"), {
    titleCased: true
  });
  const entityTypeNamePlural = this.helpers.getEntityTypeName(this.attr("entity-type"), {
    plural: true
  });

  const NameInput = function NameInput() {
    let props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    var _a, _b;

    return jsx(InputEl, {
      attrs: {
        placeholder: (_a = props === null || props === void 0 ? void 0 : props.placeHolderValue) !== null && _a !== void 0 ? _a : "Untitled ".concat(entityTypeNameTitle),
        label: (_b = props === null || props === void 0 ? void 0 : props.label) !== null && _b !== void 0 ? _b : "Name",
        'validation-status': _this.helpers.getNameError() ? "invalid" : "",
        'error-message': _this.helpers.getNameError() ? _this.helpers.getNameError() : "",
        elref: "entityNameInput",
        disabled: _this.helpers.isSavingRestricted()
      },
      props: {
        value: name
      },
      on: {
        input: _this.helpers.handleNameInput,
        keydown: _this.helpers.handleKeydown
      },
      hook: {
        insert: _ref => {
          let {
            elm
          } = _ref;
          return _this.setElRef("nameInput", elm);
        },
        destroy: () => _this.setElRef("nameInput", null)
      }
    });
  };

  const InputDescription = _ref2 => {
    let {
      text,
      learnMoreLink
    } = _ref2;
    return jsx("div", {
      sel: '.input-description'
    }, jsx("div", {
      sel: '.input-description-text'
    }, text ? text : ""), learnMoreLink ? jsx("a", {
      sel: '.input-description-learn-more',
      attrs: {
        href: learnMoreLink,
        target: "_blank"
      }
    }, "Learn More") : null);
  };

  return jsx(ModalEl, {
    sel: '.modal.create-entity-modal',
    attrs: {
      open: this.attr("open"),
      'modal-title': this.attr("modal-title"),
      'modal-description': "Modal for managing ".concat(entityTypeNamePlural)
    },
    on: {
      change: this.helpers.handleModalChange
    }
  }, jsx("div", {
    sel: '.mp-card-header'
  }, jsx("div", {
    sel: '.mp-card-header-title'
  }, this.attr("modal-title"))), jsx("div", {
    sel: '.mp-modal-content'
  }, this.helpers.limitBannerRenderer(), this.helpers.isSavingRestricted() ? jsx(BannerEl, {
    sel: '.banner',
    attrs: {
      theme: "info",
      type: BannerType.Embedded,
      'header-text': "Upgrade to create and save cohort criteria",
      'body-text': "When you upgrade your plan, cohorts can be created and saved to use across all reports in a project",
      ctas: [{
        text: "Upgrade",
        icon: "share",
        actionName: BannerAction.Upgrade
      }],
      'style-override': ".banner-wrapper .banner-panel .banner-copy {width: calc(100% - 130px)}"
    },
    on: {
      action: this.helpers.openPricingUpsell
    }
  }) : jsx(null, null, !this.attr("show-global-access-menu") || this.helpers.userLacksVisibilityPerms() ? jsx(SharingBannerEl, {
    sel: '.banner',
    attrs: {
      'project-id': this.attr("project-id"),
      'entity-type': this.attr("entity-type")
    }
  }) : null, this.attr("warning") ? jsx(BannerEl, {
    sel: '.banner',
    attrs: {
      theme: "warn",
      type: BannerType.Embedded,
      'body-text': this.attr("warning")
    }
  }) : null), this.attr("entity-type") === "data group" ? jsx(null, null, jsx(NameInput, {
    label: 'Event property',
    placeHolderValue: 'eg. company_id'
  }), jsx(InputDescription, {
    text: 'Type an event property to use as a Unique Group Identifier',
    learnMoreLink: 'https://help.mixpanel.com/hc/en-us/articles/360025333632#implementation'
  }), jsx(InputEl, {
    attrs: this.helpers.getDataGroupDescriptionInputAttrs(),
    props: {
      value: description
    },
    on: {
      input: this.helpers.handleDescriptionInput,
      keydown: this.helpers.handleKeydown
    },
    hook: {
      insert: _ref3 => {
        let {
          elm
        } = _ref3;
        return this.setElRef("descriptionTextarea", elm);
      },
      destroy: () => this.setElRef("descriptionTextarea", null)
    }
  }), jsx(InputDescription, {
    text: 'The group key name that displays in the Mixpanel interface'
  })) : jsx(null, null, jsx(NameInput, null), jsx(InputEl, {
    attrs: this.helpers.getDescriptionInputAttrs(),
    props: {
      value: description
    },
    on: {
      input: this.helpers.handleDescriptionInput,
      keydown: this.helpers.handleKeydown
    },
    hook: {
      insert: _ref4 => {
        let {
          elm
        } = _ref4;
        return this.setElRef("descriptionTextarea", elm);
      },
      destroy: () => this.setElRef("descriptionTextarea", null)
    }
  })), this.helpers.showGlobalAccessMenu() ? jsx("div", {
    sel: '.global-access-container'
  }, jsx("div", {
    sel: '.label'
  }, "Who Can See This?"), jsx(SelectEl, {
    sel: '.global-access-select',
    attrs: {
      sections: JSON.stringify(this.helpers.getGlobalAccessTypeSections()),
      'selected-option': globalAccessType,
      'label-transform': "uppercase",
      size: "large",
      elref: "globalAccessMenu"
    },
    on: {
      change: this.helpers.handleGlobalAccessTypeChange
    }
  })) : null, jsx("div", {
    sel: '.modal-footer'
  }, jsx("div", {
    sel: '.modal-actions'
  }, this.attr("show-share-management") && !this.attr("show-copy-link-button") ? jsx("div", {
    sel: '.modal-actions-confrim-share-container'
  }, jsx(ButtonEl, {
    attrs: {
      theme: ButtonTheme.Secondary,
      disabled: !this.helpers.formIsValid() || Boolean(saving),
      elref: "saveAndShareButton"
    },
    on: {
      click: () => this.helpers.saveChanges(true)
    }
  }, this.helpers.showGlobalAccessMenu() ? "Customize Access" : "Save and Share")) : null, this.attr("show-copy-link-button") && !this.attr("show-share-management") ? jsx("div", {
    sel: '.modal-actions-confrim-share-container'
  }, jsx(TooltipEl, {
    attrs: {
      text: "Copy the current URL"
    }
  }), jsx(AsyncButtonEl, {
    attrs: {
      theme: ButtonTheme.Secondary,
      elref: "copyLinkButton",
      icon: "link"
    },
    props: {
      asyncAction: this.helpers.copyLink
    }
  }, "Copy Link")) : null, jsx("div", {
    sel: '.modal-actions-cancel-container'
  }, jsx(ButtonEl, {
    sel: '.modal-actions-cancel',
    attrs: {
      theme: ButtonTheme.Tertiary,
      elref: "cancelButton"
    },
    on: {
      click: this.helpers.handleSaveModalCancel
    }
  }, "Cancel")), jsx("div", {
    sel: '.modal-actions-confirm-container',
    on: {
      click: this.helpers.setSubmitAttempted
    }
  }, jsx(ButtonEl, {
    sel: '.modal-actions-confirm',
    attrs: {
      theme: ButtonTheme.Primary,
      disabled: !this.helpers.formIsValid() || Boolean(saving),
      // eslint-disable-next-line @typescript-eslint/no-misused-promises
      icon: saving ? "spinner" : "",
      elref: "saveEntityButton"
    },
    on: {
      click: () => this.helpers.saveChanges(false)
    }
  }, // eslint-disable-next-line @typescript-eslint/no-misused-promises
  saving ? "Saving" : "Save"))))));
}